import { ActionMeta, ValueType, OptionTypeBase } from 'react-select';
import { useCallback } from 'react';
import { useTrack } from '@app/analytics';

export const useTrackReactSelect = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>(
  trackingName?: string,
  callback?: (
    value: ValueType<OptionType, IsMulti>,
    actionMeta: ActionMeta<OptionType>,
  ) => void,
) => {
  const track = useTrack();
  return useCallback(
    (
      value: ValueType<OptionType, IsMulti>,
      actionMeta: ActionMeta<OptionType> & {
        option?: OptionType | null;
        removedValue?: OptionType | null;
      },
    ) => {
      if (!trackingName && callback) {
        return callback(value, actionMeta);
      }
      const { name, action } = actionMeta;

      let option = actionMeta.option || actionMeta.removedValue;
      if (!option && !Array.isArray(value)) {
        option = value as OptionType;
      }

      const label = !option
        ? ''
        : option.label || option.name || option.value || option.id;

      track(`${trackingName} Changed`, {
        label,
        actionName: action,
        fieldName: name,
      });
      if (callback) {
        return callback(value, actionMeta);
      }
    },
    [callback, track], //eslint-disable-line react-hooks/exhaustive-deps
  );
};
